module.exports = {
	"apiEndpoint": "https://bbyo-api-development.herokuapp.com/api/v1",
	"publicEndpoint": "https://bbyo.rawfishindustries.com/",
	"facebookAppId": "920258291402212",
	"stripePublishableKey": "pk_test_umtjH6YlxvIiDv0VKX5JB1vV",
	"amazonUrl": "https://onetable-dev.s3.amazonaws.com/",
	"googleKey": "AIzaSyB0VgLqty-SkmfMeT33HVO_oLK0SNLOt_g",
	"isOnward": false
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/json-loader!./config-development.json
 ** module id = 233
 ** module chunks = 1
 **/